import React, { memo, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import ProductListRecommendation from './ProductListRecommendation';


const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    ); 
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});


const RecommendedProductsHome = () => {
    const { lang } = useParams();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: "home", field: 'HotDealsToday', language: "en-US" });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === "" ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status])

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

  
    return (
        <section className="recommended-products py-80">
            <div className="container container-md">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Recommended for you</h5>
                        <div className="flex-align mr-point gap-16">
                            {/* <Link
                                to="/products"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                View All Deals
                            </Link> */}
                            <Link
                                to="/products"
                                className="bg-white border-main-one-600 text-gray-700 hover-bg-main-one-600 hover-text-white  rounded-pill py-10 px-20"
                            >
                                All
                            </Link>
                             <Link
                                to="/products"
                                className="bg-white border-main-one-600 text-gray-700 hover-bg-main-one-600 hover-text-white  rounded-pill py-10 px-20"
                            >
                                Grocery
                            </Link>
                             <Link
                                to="/products"
                                className="bg-white border-main-one-600 text-gray-700 hover-bg-main-one-600 hover-text-white  rounded-pill py-10 px-20"
                            >
                                Fruits
                            </Link>
                             <Link
                                to="/products"
                                className="bg-white border-main-one-600 text-gray-700 hover-bg-main-one-600 hover-text-white  rounded-pill py-10 px-20"
                            >
                                Juice
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="row g-12">
                    
                    <div className="col-md-12">
                        <ProductListRecommendation />
                        
                    </div>
                </div>
            </div>
        </section>

    )
}

export default RecommendedProductsHome